module.exports = __webpack_public_path__ + "img/top-title.b4b964c2.png";